module.exports = __webpack_public_path__ + "static/media/en.416c2cea.svg";